import React from "react";

export default function Flutter() {
  return (
    <div>
      <svg
        width="60"
        height="102"
        viewBox="0 0 82 102"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5388_6925)">
          <mask
            id="mask0_5388_6925"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="82"
            height="102"
          >
            <path
              d="M82 47.0634L54.6614 74.5238L82 101.984H50.7581L23.4195 74.5238L50.7581 47.0634H82ZM50.774 0L0 51L15.6289 66.6984L82 0H50.7581H50.774Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_5388_6925)">
            <path
              d="M23.4354 74.5404L39.0484 90.2388L82 47.0801H50.7581L23.4195 74.5404H23.4354Z"
              fill="#39CEFD"
            />
          </g>
          <mask
            id="mask1_5388_6925"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="82"
            height="102"
          >
            <path
              d="M82 47.0634L54.6614 74.5238L82 101.984H50.7581L23.4195 74.5238L50.7581 47.0634H82ZM50.774 0L0 51L15.6289 66.6984L82 0H50.7581H50.774Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_5388_6925)">
            <path
              d="M50.774 0H82.0159L15.6289 66.6825L0 51L50.774 0Z"
              fill="#39CEFD"
            />
          </g>
          <mask
            id="mask2_5388_6925"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="82"
            height="102"
          >
            <path
              d="M82 47.0634L54.6614 74.5238L82 101.984H50.7581L23.4195 74.5238L50.7581 47.0634H82ZM50.774 0L0 51L15.6289 66.6984L82 0H50.7581H50.774Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_5388_6925)">
            <path
              d="M39.0484 90.2219L50.774 101.984H82.0159L54.6773 74.5234L39.0484 90.2219Z"
              fill="#03569B"
            />
          </g>
          <mask
            id="mask3_5388_6925"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="82"
            height="102"
          >
            <path
              d="M82 47.0634L54.6614 74.5238L82 101.984H50.7581L23.4195 74.5238L50.7581 47.0634H82ZM50.774 0L0 51L15.6289 66.6984L82 0H50.7581H50.774Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_5388_6925)">
            <path
              d="M62.214 82.1575L54.6614 74.5234L39.0325 90.2219L62.1982 82.1575H62.214Z"
              fill="url(#paint0_linear_5388_6925)"
            />
          </g>
          <mask
            id="mask4_5388_6925"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="82"
            height="102"
          >
            <path
              d="M82 47.0634L54.6614 74.5238L82 101.984H50.7581L23.4195 74.5238L50.7581 47.0634H82ZM50.774 0L0 51L15.6289 66.6984L82 0H50.7581H50.774Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_5388_6925)">
            <path
              d="M23.4354 74.5246L39.0642 58.8262L54.6931 74.5246L39.0642 90.223L23.4354 74.5246Z"
              fill="#16B9FD"
            />
          </g>
          <path
            d="M82 47.0634L54.6614 74.5237L82 101.984H50.7581L23.4195 74.5237L50.7581 47.0634H82ZM50.774 0L0 51L15.6289 66.6984L82 0H50.7581H50.774Z"
            fill="url(#paint1_radial_5388_6925)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_5388_6925"
            x1="13.9089"
            y1="77.6577"
            x2="25.2901"
            y2="66.3279"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1A237E" stop-opacity="0.4" />
            <stop offset="1" stop-color="#1A237E" stop-opacity="0" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_5388_6925"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(396.897 192.653) scale(161.299 162.017)"
          >
            <stop stop-color="white" stop-opacity="0.1" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </radialGradient>
          <clipPath id="clip0_5388_6925">
            <rect width="82" height="102" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
